import React, { useState, useEffect } from 'react';
import moment from 'moment';
import DateFnsUtils from '@date-io/moment';
import { makeStyles } from '@material-ui/styles';
import {
  PROPOSAL_LIST_STATUS,
} from '../../../utils/ConstantsMain';
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@material-ui/core';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
//import './FilterArticle.scss';

moment.updateLocale('es', {
  week: {
    dow: 7,
  },
  months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split(
    '_'
  ),
  weekdaysShort: 'DO_LU_MA_MI_JU_VI_SA'.split('_'),
});

const useStyles = makeStyles({
  textField: {
    maxWidth: 304,
    margin: '10px 0 24px',
    height: 48,
    padding: 0,
  },
  cleanFilter: {
    color: '#10587f',
    fontSize: 16,
    fontWeight: 'bold',
    textTransform: 'inherit',
  },
  buttons: {
    margin: '8px 0 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  mainLinkStyle: {
    marginBottom: 16,
  },
  mainButtonStyle: {
    minWidth: 240,
  },
  linkStyle: {
    margin: '0 60px 0 0',
  },
  buttonStyle: {
    minWidth: 168,
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 22,
    bottom: 0,
    paddingRight: 20,
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    zIndex: 10,
    right: 'unset',
    backgroundColor: '#fff',
    height: 'fit-content',
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  labelStyle: {
    fontSize: 16,
    color: '#10587f',
    fontWeight: 'bold',
  },
});

const FilterArticleForm = (props) => {
  const {
    values,
    handleChange,
    //handleBlur,
    handleSubmit,
    touched,
    errors,
    isValid,
    setFieldValue,
    //handleReset,
    //searchEvery,
    //handleFlagEvery,
    handleCleanFilter,
  } = props;

  const classes = useStyles();

  /* const searchAll = () => {
    handleFlagEvery(true);
    searchEvery();
  }; */

  const [createdAt, setStartDate] = useState(null);

  const handleDateChange = (date) => {
    console.log('fecha seleccionada', date)
    setStartDate(date);
    setFieldValue('createdAt', date);
  };

  useEffect(() => {
    if (!values.createdAt) {
      setStartDate(null);
    }
  }, [values.createdAt]);

  return (
    <form className="filterArticleForm">
      <div>
        <p className={classes.labelStyle}>Fecha</p>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            disableToolbar
            inputVariant="outlined"
            name="createdAt"
            variant="inline"
            format="DD/MM/yyyy"
            margin="normal"
            id="date-picker-inline"
            label="Fecha de creación"
            value={createdAt}
            onChange={handleDateChange}
            className={classes.textField}
            invalidDateMessage="Fecha inválida"
            maxDateMessage="Fecha más grande que la actual"
            minDateMessage="Fecha mucho más pequeña que la actual"
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            keyboardIcon={
              <img src="/img/admin/calendar.svg" alt="calendar-icon" />
            }
          />
        </MuiPickersUtilsProvider>
        {/* <p className={classes.labelStyle}>Estatus</p>
        <FormControl
          classes={{ root: classes.textField }}
          variant="outlined"
          error={touched.status && errors.status ? true : false}
        >
          <InputLabel
            htmlFor="select-multiple-checkbox"
            classes={{
              root: classes.inputLabelRoot,
              shrink: classes.inputLabelShrink,
            }}
          >
            {'Estatus de la propuesta económica'}
          </InputLabel>
          <Select
            name="status"
            value={values.status ? values.status : []}
            onChange={handleChange}
          >
            {PROPOSAL_LIST_STATUS &&
              PROPOSAL_LIST_STATUS.map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
          </Select>
          {touched.status && errors.status ? (
            <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
              {errors.status}
            </FormHelperText>
          ) : (
            ''
          )}
        </FormControl> */}
      </div>

      <div className={classes.buttons}>
          <ButtonBase
            type="submit"
            onClick={handleSubmit}
            variant="primary"
            disabled={!isValid}
            linkStyle={classes.mainLinkStyle}
            buttonStyle={classes.mainButtonStyle}
          >
            Filtrar
          </ButtonBase>

          <Button
            type="button"
            component="span"
            onClick={handleCleanFilter}
            className={classes.cleanFilter}
          >
            Limpiar filtros
          </Button>
      </div>
    </form>
  );
};

export default FilterArticleForm;
